// Site chrome settings (site name, locale, banner titles, layout overrides)
// are stored in the admin's `global_seo_settings` table and exposed via
// `GET /api/v1/settings` (admin) → proxied to `/api/v1/settings` (Next.js)
// so the API key never reaches the browser. Fetched once at build time;
// cached for an hour so subsequent SSG re-uses the result.

import { getProjects as cmsGetProjects } from "@/lib/cms";

let cached = null;
let cachedAt = 0;
const TTL_MS = 60 * 60 * 1000;

export const fetchGlobalSettings = async () => {
  const now = Date.now();
  if (cached && now - cachedAt < TTL_MS) return cached;
  try {
    // Call our own /api/v1/settings (same-origin in both browser and SSR).
    // The route forwards to the admin with the server-side CMS_API_KEY.
    const r = await fetch("/api/v1/settings", {
      headers: { Accept: "application/json" },
    });
    if (r.ok) {
      const json = await r.json();
      if (json && json.data) {
        cached = json.data;
        cachedAt = now;
        return cached;
      }
    }
  } catch {
    // fall through to defaults
  }
  cached = {};
  cachedAt = now;
  return cached;
};

/** Safe getter with a hardcoded fallback (used in JSX defaults when the
 *  admin hasn't set a value yet). */
export const getGlobalSetting = (settings, key, fallback = "") => {
  const v = settings ? settings[key] : "";
  if (v === "" || v == null) return fallback;
  return v;
};

// Re-export so the import shape stays flat for callers that already
// pull from "@/lib/cms".
export { cmsGetProjects };
